"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewHeader = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const lib_1 = require("../../lib");
const ViewHeaderMiddle_1 = require("./ViewHeaderMiddle");
const ViewHeaderEnd_1 = require("./ViewHeaderEnd");
const Dropdown_1 = require("../Dropdown");
const ViewHeaderLoader_1 = require("./ViewHeaderLoader");
const ViewHeaderComponent = ({ children, className, title, filterIcon, archiveFilter, onArchiveFilterChange }) => {
    function handleArchiveFilterChange(value) {
        return () => {
            if (onArchiveFilterChange)
                onArchiveFilterChange(value);
        };
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, lib_1.classnames)(className, (0, lib_1.bem)('view-header')) }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "view-header__start" }, { children: [archiveFilter && ((0, jsx_runtime_1.jsxs)(Dropdown_1.Dropdown, Object.assign({ className: (0, lib_1.bem)('view-header__title-dropdown'), withCaret: true }, { children: [(0, jsx_runtime_1.jsx)(Dropdown_1.Dropdown.Target, { children: (0, jsx_runtime_1.jsx)("h2", Object.assign({ className: "view-header__title" }, { children: title }), void 0) }, void 0), (0, jsx_runtime_1.jsxs)(Dropdown_1.Dropdown.Menu, { children: [(0, jsx_runtime_1.jsxs)(Dropdown_1.Dropdown.Item, Object.assign({ selected: archiveFilter === 'active', icon: filterIcon, onClick: handleArchiveFilterChange('active') }, { children: ["All ", title] }), void 0), (0, jsx_runtime_1.jsx)(Dropdown_1.Dropdown.Item, Object.assign({ selected: archiveFilter === 'archived', icon: "archive", onClick: handleArchiveFilterChange('archived') }, { children: "Archived" }), void 0)] }, void 0)] }), void 0)), !archiveFilter && (0, jsx_runtime_1.jsx)("h2", Object.assign({ className: "view-header__title" }, { children: title }), void 0)] }), void 0), children] }), void 0));
};
/**
 * ViewHeader component
 *
 * @visibleName ViewHeader
 */
class ViewHeader extends react_1.default.Component {
    render() {
        return (0, jsx_runtime_1.jsx)(ViewHeaderComponent, Object.assign({}, this.props), void 0);
    }
}
exports.ViewHeader = ViewHeader;
ViewHeader.Middle = ViewHeaderMiddle_1.ViewHeaderMiddle;
ViewHeader.End = ViewHeaderEnd_1.ViewHeaderEnd;
ViewHeader.Loader = ViewHeaderLoader_1.ViewHeaderLoader;
//# sourceMappingURL=ViewHeader.js.map